export default "__VITE_ASSET__Du5SG6w0__"